import isEqual from 'lodash/isEqual';
import type { IconAsset, Scene } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

export enum IconType {
    WAVEFORM = 'waveform',
    REGULAR = 'regular',
}

export function getIconType(icon: IconAsset): IconType {
    return icon.playbackMode === VideoData.PLAYBACK_WAVEFORM ? IconType.WAVEFORM : IconType.REGULAR;
}

export function getSwappableIconAssets(scene: Scene, iconType: IconType): IconAsset[] {
    return scene
        .getAssetsByType(VideoData.ICON_ASSET_TYPE)
        .filter((a) => a.isEditable && getIconType(a) === iconType);
}

export function isIconBlank(icon: IconAsset): boolean {
    return isEqual(icon.sourceData, VideoData.INVISIBLE_LOTTIE);
}
